import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "persistent-file-storage"
    }}>{`Persistent File Storage`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "localFileSystem.md"
        }}>{`localFileSystem`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FileSystemProvider.md"
        }}>{`FileSystemProvider`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Entry.md"
        }}>{`Entry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "EntryMetadata.md"
        }}>{`EntryMetadata`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "File.md"
        }}>{`File`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Folder.md"
        }}>{`Folder`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "domains.md"
        }}>{`domains`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "types.md"
        }}>{`types`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "formats.md"
        }}>{`formats`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "modes.md"
        }}>{`modes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "fileTypes.md"
        }}>{`fileTypes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "errors.md"
        }}>{`errors`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      